<agr-page-tabs>
  <div class="wrapper--spacing-horizontal spacing--margin-bottom">
    <h1 class="text--h1 page-title">{{ 'insemination-advice.title' | translate }}</h1>
    <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="spacing--margin-bottom--large">
      <a
        mat-tab-link
        [routerLink]="'/insemination-advice/overview'"
        routerLinkActive
        #overview="routerLinkActive"
        [active]="overview.isActive"
      >
        {{ 'insemination-advice.overview-title' | translate }}
      </a>
      <a
        mat-tab-link
        [routerLink]="'/insemination-advice/alva'"
        routerLinkActive
        #alva="routerLinkActive"
        [active]="alva.isActive"
      >
        {{ 'insemination-advice.alva-title' | translate }}
      </a>
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <div class="wrapper--spacing-vertical">
        <router-outlet></router-outlet>
      </div>
    </mat-tab-nav-panel>
  </div>
</agr-page-tabs>
